import { Autocomplete, Box, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';

import ControlledCheckbox from '~components/Form/ControlledCheckbox';
import { getSipQueues } from '~pages/SipConfiguration/api';
import { SipQueue } from '~pages/SipConfiguration/domain';
import useSipQueues from '~pages/SipConfiguration/useSipQueues';

import BaseNode from '../BaseNode';
import { ContactFlowNodeProps } from '..';

export default function EnqueueNode(props: ContactFlowNodeProps) {
  const queueId = props.data.parameter.enqueue?.queueId;
  const form = useForm<{
    queue: SipQueue;
    csat: boolean;
  }>();
  useEffect(() => {
    if (queueId) {
      (async () => {
        const res = await getSipQueues({
          queueIds: [queueId],
        });
        form.reset({
          queue: res?.queues[0],
        });
      })();
    }
  }, []);
  return (
    <BaseNode
      {...props}
      title='Enqueue'
      parameterForm={form}
      renderParameterForm={(enqueue) => {
        const { queue, csat } = enqueue ?? {};
        return (
          <>
            <Typography>
              Queue: {queue?.queueName || '--'} #{queue?.queueID ?? '--'}
            </Typography>
            <Typography>CSAT: {csat ? 'Yes' : 'No'}</Typography>
          </>
        );
      }}
      transformParameter={({ queue, csat }) => ({ enqueue: { queueId: queue.queueID, csat } })}
      renderEditParameter={({ control }, { isEdit }) => {
        const [search, setSearch] = useState<string>('');
        const { list, loading } = useSipQueues({ search, shouldFetch: isEdit });
        return (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
            }}>
            <Controller
              control={control}
              name='queue'
              render={({ field: { onChange, value, ...rest } }) => (
                <Autocomplete
                  {...rest}
                  fullWidth
                  filterSelectedOptions
                  options={list}
                  loading={loading}
                  loadingText='Fetching queues...'
                  onInputChange={(_, v) => setSearch(v)}
                  renderInput={(params) => <TextField {...params} label='Queue' />}
                  getOptionLabel={(v) => `${v.queueName} #${v.queueID}`}
                  isOptionEqualToValue={(o, v) => o.queueID === v.queueID}
                  onChange={(e, v) => onChange(v)}
                  value={value || null}
                />
              )}
            />
            <ControlledCheckbox control={control} name='csat' label='CSAT' defaultValue={false} />
          </Box>
        );
      }}
    />
  );
}
